import { useEffect } from 'react';

export function avisarOcioso(ocioso: boolean): void {
  void window.pdvDesktop?.totemOcioso?.(ocioso);
}

export function useAvisarOcioso(ocioso: boolean): void {
  useEffect(() => {
    avisarOcioso(ocioso);

    return () => avisarOcioso(false);
  }, [ocioso]);
}
